(function () {
  'use strict';

  /* @ngdoc object
   * @name investments
   * @description
   *
   */
  angular
    .module('investments', [
      'ui.router'
    ]);
}());
